export default {
  namespaced: true,

  state: () => ({
    articles: {
      data: [],
      links: {},
      meta: {},
    },
    article: {},
    isLoading: false,
    labelForm: {
      media: {
        title: 'Foto Artikel',
        description: [],
      },
      title: {
        title: 'Judul Artikel',
        description: [],
      },
      slug: {
        title: 'Slug',
        description: [],
      },
      content: {
        title: 'Content',
        description: [],
      },
      type: {
        title: 'Kategori Artikel',
        description: [],
      },
      publish: {
        title: 'Publikasi',
        description: [],
      },
      highlight: {
        title: 'Highlight',
        description: ['Atur sebagai highlight agar artikel registry ditampilkan di halaman utama Miniapoly'],
      },
      order: {
        title: 'Urutan',
        description: ['Tentukan di urutan ke berapa artikel registry ini akan ditampilkan'],
      },
      registry_title: {
        title: 'Judul Registry',
        description: ['Beri judul Registry seperti "Meghan & Harry Registry"'],
      },
      registry_photo: {
        title: 'Foto Registry',
        description: ['Dapat berisi foto Ibu, bayi dll. Foto akan ditampilkan dengan bentuk bulat'],
      },
      user: {
        title: 'Pemilik Registry',
        description: ['Dapat berisi nama lengkap Ibu'],
      },
      merchant: {
        title: 'Merchant',
        description: [],
      },
    },
  }),

  getters: {},

  mutations: {
    SET_ARTICLE_LIST(state, payload) {
      state.articles = payload
    },
    SET_ARTICLE(state, payload) {
      state.article = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
  },

  actions: {
    async getArticles({ commit }, { page = null, categoryId = [], keyword = '' } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/article'

        const response = await this._vm.$http.get(url, {
          params: {
            page,
            'filter[article_category_id]': categoryId,
            'filter[keyword]': keyword,
          },
        })

        commit('SET_ARTICLE_LIST', response.data)

        commit('SET_LOADING', false)
        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        commit('SET_LOADING', false)
        return error
      }
    },
    async deleteArticle({ commit, dispatch }, { articleId }) {
      try {
        const url = `/v1/admin/article/${articleId}`

        const response = await this._vm.$http.delete(url)

        dispatch('getArticles')

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Artikel!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Artikel!',
        }, { root: true })

        return error
      }
    },
    async createArticle({ commit }, data) {
      try {
        const url = '/v1/admin/article'
        const response = await this._vm.$http.post(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Artikel!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Artikel!',
        }, { root: true })

        return false
      }
    },
    async getArticle({ commit }, { id }) {
      try {
        const url = `/v1/admin/article/${id}`

        const response = await this._vm.$http.get(url)

        commit('SET_ARTICLE', response.data.data)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },
    async updateArticle({ commit }, { articleId, data }) {
      try {
        const url = `/v1/admin/article/${articleId}`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Artikel!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Artikel!',
        }, { root: true })

        return false
      }
    },
  },
}
